<template>
  <div class="side">
    <div class="title">
      {{title}}
    </div>
    <div class="items">
      <ul>
      	<li
        @click="enterDetail(item.id)"
        v-for="(item,index) in list"
        :key="index"
        >{{item.title || item.name}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default{
    name:'SideContent',
    props:{
      list:{
        type:Array,
        default(){
          return []
        }
      },
      title:{
        type:String,
        default:''
      }

    },
    data(){
      return {
        isActive:false
      }
    },
    mounted() {
    },
    methods:{
      enterDetail(id){
        if(this.$route.path == ('/articleInfo/'+id)){
          return
        }else{
          this.$router.push({
            path:'/articleInfo/'+id,
          })
        }
        this.$emit('getDetail',id)
      },
    }
  }
</script>

<style lang="scss">
  .side{
    background-color: #fff;
    .title{
      text-align: left;
      padding: 10px 20px;
      font-weight: 700;
      font-size: 20px;
      border-bottom: 1px solid #ccc;
    }
    .items{
      padding: 10px 30px;
      ul{
        width: 100%;
        list-style: none;
        text-align: left;
        padding-left:5px;
        list-style-image: url('../assets/index/flowers.png');
        li{
          cursor: pointer;
          padding: 3px 0px 3px 2px;
          margin: 2px 0;
          &:hover{
            background-color: #99CCFF;
            color: #fff;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SideContent.vue